module.exports = __webpack_public_path__ + "img/160.1df165f7.png";